import { useQuery } from 'react-query';
import eventLogService, { EventLogUser } from '../services/eventLog.service';

const useEventLogUsers = (clinicId: number, startDate?: string, endDate?: string) => {
  const { status, data, error, isFetching, refetch } = useQuery<{
    data: EventLogUser[];
    dates: string[];
  }>(
    ['eventLogUsers', clinicId, startDate, endDate],
    () => eventLogService.listUsers(clinicId, { startDate, endDate }),
    {
      refetchOnWindowFocus: false,
      enabled: !!clinicId,
      keepPreviousData: true,
    }
  );

  return {
    status,
    data: data?.data || [],
    dates: data?.dates || [],
    error,
    isFetching,
    refetch,
  };
};

export default useEventLogUsers;
